export const breakpoints = {
  mobileMin: '375px',
  mobileMax: '699px',
  tabletMin: '700px',
  tabletMax: '1199px',
  desktopMin: '1200px',
};
